import { apiFetch, resolveCompanyLogoUrl } from './api'

export function normalizeAuthBranch(branch) {
  if (!branch?.id) return null
  const logoUrl = resolveCompanyLogoUrl(
    branch.logo_url ||
    branch.logoUrl ||
    branch.branchLogo ||
    branch.branch_logo
  )
  return {
    id: branch.id,
    name: branch.name || '',
    modules: branch.modules ?? null,
    companyId: branch.companyId ?? branch.company_id ?? null,
    logo_url: logoUrl,
  }
}

export function withResolvedCompanyLogo(user) {
  if (!user) return user
  const company = user.company ? {
    ...user.company,
    modules: user.company.modules ?? null,
    logo_url: resolveCompanyLogoUrl(
      user.company.logo_url ||
      user.company.logoUrl ||
      user.companyLogo ||
      user.company_logo
    )
  } : user.company

  const logoUrl = company?.logo_url || resolveCompanyLogoUrl(
    user.companyLogo ||
    user.company_logo ||
    user.logo ||
    user.company?.logo_url
  )

  const branch = normalizeAuthBranch(user.branch)
  const branchLogoUrl = branch?.logo_url || resolveCompanyLogoUrl(
    user.branchLogo ||
    user.branch_logo ||
    user.branch?.logo_url ||
    user.branch?.logoUrl
  )

  return {
    ...user,
    company,
    branch: branch
      ? { ...branch, logo_url: branchLogoUrl || branch.logo_url || '' }
      : null,
    companyLogo: logoUrl,
    company_logo: logoUrl,
    logo: logoUrl,
    branchLogo: branchLogoUrl || '',
    branch_logo: branchLogoUrl || ''
  }
}

export async function switchOrgUnit({ orgType, orgId }) {
  const response = await apiFetch('/users/switch-org-unit', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      orgType: String(orgType || '').toLowerCase(),
      orgId: Number(orgId),
    }),
  })

  const data = await response.json().catch(() => ({}))
  if (!response.ok) {
    const err = new Error(data.message || 'Failed to switch organization unit')
    if (data.code) err.code = data.code
    if (data.forceLogout) err.forceLogout = true
    throw err
  }

  return {
    ...data,
    user: withResolvedCompanyLogo(data.user),
  }
}

export function parseOrgUnitSelection(selection) {
  const raw = String(selection || '')
  if (!raw) return null
  const [type, rawId] = raw.split(':')
  const selectedId = Number(rawId)
  if (!type || !Number.isInteger(selectedId) || selectedId <= 0) return null
  return { type, selectedId }
}
